import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, getDoc, Timestamp, query, where, addDoc, deleteDoc } from 'firebase/firestore';
import { db, auth } from './../../../firebaseConfig';
import Select from 'react-select';

function SetVacationPage() {
  const [talentIds, setTalentIds] = useState([]);
  const [talentData, setTalentData] = useState([]);
  const [selectedTalent, setSelectedTalent] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [availabilityStatus, setAvailabilityStatus] = useState('available'); // New state for availability
  const [schedules, setSchedules] = useState([]);
  const [editingSchedule, setEditingSchedule] = useState(null);

  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      border: 'none',
    }),
    control: (base) => ({
      ...base,
      width: '400px',
      borderColor: 'black',
      borderWidth: '1px',
      boxShadow: 'none',
      margin: '5px',
      borderRadius: '0px',
      color: 'black', // Your color
      fontWeight: "700",
      height: '50px',
      textTransform: 'uppercase',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black', // Your color
      fontWeight: "700"
    }),
    input: (provided) => ({
      ...provided,
      color: 'black', // Your color
      fontWeight: "700"
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'black' : 'inherit',
      '&:hover': { backgroundColor: state.isSelected ? 'black' : '#f7f7f7' }
    }),
  };


  useEffect(() => {
    const fetchUserTalents = async () => {
      const userDoc = await getDoc(doc(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/UserData", localStorage.getItem("userId")));
      const fetchedTalentIds = userDoc.data().talentIds;
      setTalentIds(fetchedTalentIds);

      const talentDocs = await getDocs(collection(db, "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talents_new_data"));
      const talents = talentDocs.docs.map(doc => ({ id: doc.id, name: doc.data().Name , Funktion: doc.data().Funktion}))
                                    .filter(talent => fetchedTalentIds.includes(talent.id));
      setTalentData(talents);
    };

    fetchUserTalents();
  }, []);

  useEffect(() => {
    const fetchSchedules = async () => {
      const availabilityDocs = await getDocs(collection(db, "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talentAvailability"));
      const vacationDocs = await getDocs(collection(db, "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talentVacations"));
      
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      
      const allSchedules = [
        ...availabilityDocs.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          type: 'available'
        })),
        ...vacationDocs.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          type: 'on vacation'
        }))
      ].filter(schedule => {
        if (!schedule || !schedule.endDate || !schedule.endDate.toDate) {
          return false;
        }
        
        try {
          const endDate = schedule.endDate.toDate();
          endDate.setHours(0, 0, 0, 0);
          return endDate >= currentDate && talentIds.includes(schedule.talentId);
        } catch (error) {
          console.error('Error processing schedule:', schedule);
          return false;
        }
      });
      
      setSchedules(allSchedules);
    };

    if (talentIds.length > 0) {
      fetchSchedules();
    }
  }, [talentIds]);

  useEffect(() => {
    if (editingSchedule) {
      setSelectedTalent(editingSchedule.talentId);
      setStartDate(editingSchedule.startDate.toDate().toISOString().split('T')[0]);
      setEndDate(editingSchedule.endDate.toDate().toISOString().split('T')[0]);
      setAvailabilityStatus(editingSchedule.type === 'available' ? 'available' : 'on vacation');
    }
  }, [editingSchedule]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      talentId: selectedTalent,
      startDate: Timestamp.fromDate(new Date(startDate)),
      endDate: Timestamp.fromDate(new Date(endDate)),
      lastUpdatedAt: Timestamp.fromDate(new Date()),
      updatedBy: auth.currentUser?.email || 'unknown user'
    };

    const collectionPath = availabilityStatus === 'available'
      ? "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talentAvailability"
      : "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talentVacations";

    try {
      if (editingSchedule) {
        const deleteSuccess = await handleDelete(editingSchedule.id, editingSchedule.type);
        if (!deleteSuccess) {
          throw new Error('Failed to delete old schedule');
        }
      }
      
      await addDoc(collection(db, collectionPath), data);
      
      const availabilityDocs = await getDocs(collection(db, "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talentAvailability"));
      const vacationDocs = await getDocs(collection(db, "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talentVacations"));
      
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      
      const newSchedules = [
        ...availabilityDocs.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          type: 'available'
        })),
        ...vacationDocs.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          type: 'on vacation'
        }))
      ].filter(schedule => {
        if (!schedule || !schedule.endDate || !schedule.endDate.toDate) {
          return false;
        }
        
        try {
          const endDate = schedule.endDate.toDate();
          endDate.setHours(0, 0, 0, 0);
          return endDate >= currentDate && talentIds.includes(schedule.talentId);
        } catch (error) {
          console.error('Error processing schedule:', schedule);
          return false;
        }
      });
      
      setSchedules(newSchedules);
      setEditingSchedule(null);
      
      setSelectedTalent('');
      setStartDate('');
      setEndDate('');
      setAvailabilityStatus('available');
      
      alert(editingSchedule ? 'Schedule updated successfully!' : 'Schedule set successfully!');
    } catch (error) {
      console.error('Error setting schedule: ', error);
      alert('Error updating schedule. Please try again.');
    }
  };

  const handleDelete = async (scheduleId, type) => {
    const collectionPath = type === 'available' 
      ? "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talentAvailability"
      : "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talentVacations";
      
    try {
      await deleteDoc(doc(db, collectionPath, scheduleId));
      setSchedules(schedules.filter(schedule => schedule.id !== scheduleId));
      return true; // Return success
    } catch (error) {
      console.error('Error deleting schedule: ', error);
      return false; // Return failure
    }
  };

  const handleCancelEdit = () => {
    setEditingSchedule(null);
    setSelectedTalent('');
    setStartDate('');
    setEndDate('');
    setAvailabilityStatus('available');
  };

  const talentOptions = talentData.map(talent => ({ value: talent.id, label: talent.name+"-"+talent.Funktion }));
  const availabilityOptions = [
    { value: 'available', label: 'Available' },
    { value: 'on vacation', label: 'Not Available' }
  ];
  return (
    <section>
      <div className='content-wrapper'>
        {editingSchedule ? (
          <>
            <h1>Edit Schedule</h1>
            <p style={{ color: 'red', marginBottom: '20px' }}>
              Note: If you have already accepted a job during these dates, your update will not be accepted.
            </p>
          </>
        ) : (
          <h1>Set Talent Schedule</h1>
        )}
        <form onSubmit={handleSubmit} style={{ marginTop: '40px', maxWidth: '500px' }}>
          <div>
          <Select
           //   className='talent-dropdown'
              options={talentOptions}
              value={talentOptions.find(option => option.value === selectedTalent)}
              onChange={option => setSelectedTalent(option.value)}
              styles={customStyles}
              required
            />
          </div>
      
          <div className='availability-dropdown-container'>
          <Select
              className='availability-dropdown'
              options={availabilityOptions}
              required
              value={availabilityOptions.find(option => option.value === availabilityStatus)}
              onChange={option => setAvailabilityStatus(option.value)}
              styles={customStyles}
            />
          </div>

          <div className="talent-datepicker-container" style={{ display: 'flex' }}>
            <div className="date-input-wrapper">
              <input required className='inputdate' id="start-date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
              <svg className="custom-icon" viewBox="0 0 500 500" >
                <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
              </svg>
            </div>

            <div className="date-input-wrapper">
              <input required className='inputdate' id="end-date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} required placeholder='END' />
              <svg className="custom-icon" viewBox="0 0 500 500" >
                <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
              </svg>
            </div>
          </div>
          <div style={{ marginTop: '20px' }}>
            <button className='big-button' type="submit">
              {editingSchedule ? 'Update Schedule' : 'Set Schedule'}
            </button>
            {editingSchedule && (
              <button 
                type="button" 
                onClick={handleCancelEdit}
                className='big-button'
                style={{ marginLeft: '10px', backgroundColor: '#666' }}
              >
                Cancel Edit
              </button>
            )}
          </div>
        </form>
        
        <div style={{ marginTop: '40px' }}>
          <h2>Current Schedules</h2>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {schedules.map(schedule => {
              const talent = talentData.find(t => t.id === schedule.talentId);
              const formatDate = (timestamp) => {
                if (!timestamp || !timestamp.toDate) {
                  return 'Invalid date';
                }
                return timestamp.toDate().toLocaleDateString();
              };

              const formatDateTime = (timestamp) => {
                if (!timestamp || !timestamp.toDate) {
                  return 'Invalid date';
                }
                return timestamp.toDate().toLocaleString();
              };

              return (
                <div key={schedule.id} style={{
                  border: '1px solid #ddd',
                  padding: '15px',
                  margin: '10px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <div>
                    <p><strong>Talent:</strong> {talent ? `${talent.name} - ${talent.Funktion}` : 'Unknown'}</p>
                    <p><strong>Status:</strong> {schedule.type}</p>
                    <p><strong>Period:</strong> {formatDate(schedule.startDate)} - {formatDate(schedule.endDate)}</p>
                    {schedule.lastUpdatedAt && (
                      <p style={{ fontSize: '0.9em', color: '#666' }}>
                        <strong>Last updated:</strong> {formatDateTime(schedule.lastUpdatedAt)}
                        {schedule.updatedBy && ` by ${schedule.updatedBy}`}
                      </p>
                    )}
                  </div>
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <button 
                      onClick={() => setEditingSchedule(schedule)}
                      style={{ marginRight: '10px', marginBottom: '10px' }}
                       className='big-button'
                    >
                      Edit
                    </button>
                    <button  
                      onClick={() => handleDelete(schedule.id, schedule.type)}
                      className='big-button'
                    >
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SetVacationPage;